import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8.5 16a5.5 5.5 0 1 0 -5.5 -5.5v.5","key":"svg-0"}],["path",{"d":"M3 16h18","key":"svg-1"}],["path",{"d":"M18 13l3 3l-3 3","key":"svg-2"}]]

const IconArrowIteration = createReactComponent('outline', 'arrow-iteration', 'ArrowIteration', __iconNode);

export default IconArrowIteration;